import { StyleSheet, Image } from 'react-native'
import React from 'react'

const CurvedBgImage = () => {
  return (
    <Image source={require('../../assets/curved-bg.png')} style={styles.imageStyles} resizeMode='stretch'></Image>
  )
}

export default CurvedBgImage

const styles = StyleSheet.create({
    imageStyles: {
        width: '100%',
        height: 95,
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1, // Bring image forward
    },
});